import React, { useContext, useRef } from "react";
import { Container } from "reactstrap";
import { Logo } from "../../Images";
import "./header.css";
import { AuthContext } from "../../context/AuthContext";

const Header = () => {
  const menuRef = useRef();

  const { user } = useContext(AuthContext);

  const navLinks = [
    {
      display: "Home",
      url: "/",
    },
    {
      display: "About",
      url: "/about",
    },

    {
      display: user ? "Dashboard" : "Login",
      url: user ? "/dashboard" : "/login",
    },

    {
      display: "Verify Cert",
      url: "/verify-cert",
    },
  ];

  const menuToggle = () => menuRef.current.classList.toggle("active__menu");

  return (
    <header className="header">
      <Container>
        <div className="navigation d-flex align-items-center justify-content-between">
          <div className="logo">
            <h2 className=" d-flex align-items-center gap-1 header__logo">
              <img src={Logo} alt="" />
            </h2>
            {/* <h2 className=" d-flex align-items-center gap-1">
              <i class="ri-pantone-line"></i> renaissance university.


            </h2> */}
          </div>

          <div className="nav d-flex align-items-center gap-5">
            <div className="nav__menu" ref={menuRef} onClick={menuToggle}>
              <ul className="nav__list">
                {navLinks.map((item, index) => (
                  <li key={index} className="nav__item">
                    <a href={item.url}>{item.display}</a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="nav__right">
              <p className="mb-0 d-flex align-items-center gap-2">
                <i class="ri-phone-line"></i> +234 8108660152
              </p>
            </div>
          </div>

          <div className="mobile__menu">
            <span>
              <i class="ri-menu-line" onClick={menuToggle}></i>
            </span>
          </div>
        </div>
      </Container>
    </header>
  );
};

export default Header;
